module.exports = Clipboard;


/*****************
 ** WEBPACK FOOTER
 ** external "Clipboard"
 ** module id = 50
 ** module chunks = 1
 **/